import QueryParams from 'utils/queryParams';

import {
  API_DASHBOARD_NEXT_APPOINTMENTS,
  API_DUE_APPOINTMENTS,
  API_HISTORICAL_ACTIVITIES,
  API_PATIENT_READINGS,
  API_PATIENT_READINGS_CHART,
  API_PATIENT_TASKS,
  API_PREFIX_ONEPLATFORM,
} from './constants';

export const apiPatientReadingsNew = (params = {}) => {
  return QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/${API_PATIENT_READINGS}`,
    params,
  );
};

export const apiPatientReadingsChart = (params = {}) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/${API_PATIENT_READINGS_CHART}`,
    params,
  );

export const apiDashboardNextAppointments = (
  params?: Record<string, unknown>,
) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/${API_DASHBOARD_NEXT_APPOINTMENTS}`,
    params,
  );

export const apiDueAppointments = (params?: Record<string, unknown>) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/${API_DUE_APPOINTMENTS}`,
    params,
  );

export const apiHistoricalActivities = (params?: Record<string, unknown>) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/${API_HISTORICAL_ACTIVITIES}`,
    params,
  );

export const apiPapCaseByGuid = (papCaseGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}`;

export const apiPapCaseReviewByGuid = (papCaseGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/reviews`;

export const apiPatientPapCases = (patientGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/patients/${patientGuid}/pap-cases`;

export const apiPapCaseForms = (papCaseGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/forms`;

export const apiPapCaseFormsConfirm = (papCaseGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/forms/confirm`;

export const apiPapFormDownload = (papCaseGuid: string, papFormGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/forms/${papFormGuid}/download`;

export const apiPapCaseLinks = (papCaseGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/links`;

export const apiPapCaseLinkByGuid = (papCaseGuid: string, linkGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/links/${linkGuid}`;

export const apiLetterTemplates = `${API_PREFIX_ONEPLATFORM}/letter-templates`;

export const createAttachmentPresignedUrl = (papCaseGuid: string) => {
  return `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/attachments`;
};

export const uploadAttachment = (papCaseGuid: string) => {
  return `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/attachments/confirm`;
};

export const apiPapCaseAttachmentByGuid = (
  papCaseGuid: string,
  attachmentGuid: string,
) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/attachments/${attachmentGuid}`;

export const apiPapCaseAttachmentDownload = (
  papCaseGuid: string,
  attachmentGuid: string,
) =>
  `${API_PREFIX_ONEPLATFORM}/pap-cases/${papCaseGuid}/attachments/${attachmentGuid}/download`;
export const apiPapCasesManagement = (params?: Record<string, unknown>) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/pap-cases/management`,
    params,
  );

export const apiPapCasesManagementOverview = (
  params?: Record<string, unknown>,
) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/pap-cases/status-count`,
    params,
  );

export const apiPatientTasks = (patientGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/${API_PATIENT_TASKS}/${patientGuid}/tasks`;

export const apiCreateTask = () => `${API_PREFIX_ONEPLATFORM}/tasks`;

export const apiUpdateTask = (taskGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/tasks/${taskGuid}`;

export const apiAssignTask = (taskGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/tasks/${taskGuid}/assignments`;

export const apiCompleteTask = (taskGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/tasks/${taskGuid}/completions`;

export const apiUnassignTask = (taskGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/tasks/${taskGuid}/unassignments`;

export const apiMedReconImport = (patientGuid: string) =>
  `${API_PREFIX_ONEPLATFORM}/patients/${patientGuid}/medication-reconciliations`;

export const apiMedReconListReconciliations = (
  patientGuid: string,
  params?: Record<string, unknown>,
) =>
  QueryParams.stringifyUrl(
    `${API_PREFIX_ONEPLATFORM}/patients/${patientGuid}/medication-reconciliations`,
    params,
  );

export const apiMedReconGetReconciliation = (
  patientGuid: string,
  reconciliationGuid: string,
) =>
  `${API_PREFIX_ONEPLATFORM}/patients/${patientGuid}/medication-reconciliations/${reconciliationGuid}`;

export const apiMedReconAction = (
  patientGuid: string,
  reconciliationGuid: string,
) =>
  `${API_PREFIX_ONEPLATFORM}/patients/${patientGuid}/medication-reconciliations/${reconciliationGuid}/action`;
